import { carePhaseDefs } from '@shared';
import {
  OnboardingCareSettings,
  OnboardingCareSettingsPhaseOne,
  OnboardingCareSettingsPhaseTwo,
  OnboardingCareSettingsPhaseThree,
} from '@/pages/OnboardingCareSettings';

const GENWORTH_PREFERENCE_LABEL = 'Typical Preference';

function genworthCarePrompt({
  clientFirstName,
  phaseLabel,
  isCurrentPhase,
}: {
  clientFirstName: string;
  phaseLabel: string;
  isCurrentPhase: boolean;
}) {
  return isCurrentPhase
    ? `Where is ${clientFirstName} receiving care during ${phaseLabel}?`
    : `Where would ${clientFirstName} want to receive care during ${phaseLabel}?`;
}

export function GenworthOnboardingCareSettingsPhaseOne(_props: ClientIdProps) {
  return (
    <OnboardingCareSettings
      carePhase={carePhaseDefs.earlyCare.value}
      slidePage={OnboardingCareSettingsPhaseOne}
      predictedPreferenceLabel={GENWORTH_PREFERENCE_LABEL}
      getCarePrompt={genworthCarePrompt}
    />
  );
}

export function GenworthOnboardingCareSettingsPhaseTwo(_props: ClientIdProps) {
  return (
    <OnboardingCareSettings
      carePhase={carePhaseDefs.moderateCare.value}
      slidePage={OnboardingCareSettingsPhaseTwo}
      predictedPreferenceLabel={GENWORTH_PREFERENCE_LABEL}
      getCarePrompt={genworthCarePrompt}
    />
  );
}

export function GenworthOnboardingCareSettingsPhaseThree(_props: ClientIdProps) {
  return (
    <OnboardingCareSettings
      carePhase={carePhaseDefs.fullCare.value}
      slidePage={OnboardingCareSettingsPhaseThree}
      predictedPreferenceLabel={GENWORTH_PREFERENCE_LABEL}
      getCarePrompt={genworthCarePrompt}
    />
  );
}
